import React from 'react';
import { Handle, Position } from 'reactflow';
import { FileVideo } from 'lucide-react';
import type { WorkflowNodeProps } from './NodeTypes';

const InputNode: React.FC<WorkflowNodeProps> = ({ data, isConnectable, selected }) => (
  <div className={'flow-node flow-node--input' + (selected ? ' is-selected' : '')}>
    <div className="flow-node__header">
      <span className="flow-node__icon"><FileVideo size={16} /></span>
      <div><strong>{data.label || '输入文件'}</strong><span>MEDIA SOURCE</span></div>
    </div>
    <div className="flow-node__file">{data.params?.filename || '设置输入路径'}</div>
    <div className="flow-node__ports"><span><i className="port-marker port-marker--video" aria-hidden="true" />视频输出</span><span><i className="port-marker port-marker--audio" aria-hidden="true" />音频输出</span></div>
    <Handle type="source" position={Position.Right} id="video" aria-label="视频输出端口" title="视频输出" className="flow-handle flow-handle--source flow-handle--video" style={{ top: '37%' }} isConnectable={isConnectable} />
    <Handle type="source" position={Position.Right} id="audio" aria-label="音频输出端口" title="音频输出" className="flow-handle flow-handle--source flow-handle--audio" style={{ top: '66%' }} isConnectable={isConnectable} />
  </div>
);

export default InputNode;
